import * as tslib_1 from "tslib";
import * as dayjs from 'dayjs';
import api from 'src/api';
import { observable, action, computed } from 'mobx';
import { stringComparer } from 'src/utils/comprasion';
var resource = 'api/time/overview/';
var TimeOverviewStore = /** @class */ (function () {
    function TimeOverviewStore() {
        this.items = [];
        this.textFilter = '';
        this.baseDate = dayjs()
            .startOf('month')
            .toDate();
    }
    TimeOverviewStore.prototype.load = function (userId) {
        if (userId === void 0) { userId = null; }
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.userId = userId || this.userId;
                        return [4 /*yield*/, api.get(resource, {
                                params: {
                                    userId: this.userId,
                                    start: this.startDate,
                                    end: this.endDate
                                }
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        this.items = data;
                        return [2 /*return*/];
                }
            });
        });
    };
    TimeOverviewStore.prototype.setDate = function (date) {
        this.baseDate = dayjs(date)
            .endOf('week')
            .startOf('month')
            .toDate();
    };
    Object.defineProperty(TimeOverviewStore.prototype, "startDate", {
        get: function () {
            return dayjs(this.baseDate)
                .startOf('month')
                .toDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeOverviewStore.prototype, "endDate", {
        get: function () {
            return dayjs(this.baseDate)
                .endOf('month')
                .toDate();
        },
        enumerable: true,
        configurable: true
    });
    TimeOverviewStore.prototype.itemsByDay = function (day) {
        if (!this.items) {
            return;
        }
        var search = this.textFilter;
        return this.items
            .filter(function (i) { return stringComparer(i.title, search) || stringComparer(i.subtitle, search); })
            .filter(function (i) {
            var a = dayjs(i.date);
            var b = dayjs(day);
            return a.isSame(b, 'year') && a.isSame(b, 'month') && a.isSame(b, 'day');
        });
    };
    tslib_1.__decorate([
        observable
    ], TimeOverviewStore.prototype, "baseDate", void 0);
    tslib_1.__decorate([
        observable
    ], TimeOverviewStore.prototype, "items", void 0);
    tslib_1.__decorate([
        observable
    ], TimeOverviewStore.prototype, "textFilter", void 0);
    tslib_1.__decorate([
        action.bound
    ], TimeOverviewStore.prototype, "load", null);
    tslib_1.__decorate([
        action
    ], TimeOverviewStore.prototype, "setDate", null);
    tslib_1.__decorate([
        computed
    ], TimeOverviewStore.prototype, "startDate", null);
    tslib_1.__decorate([
        computed
    ], TimeOverviewStore.prototype, "endDate", null);
    return TimeOverviewStore;
}());
export default TimeOverviewStore;



//////////////////
// WEBPACK FOOTER
// ./src/store/TimeOverviewStore.ts
// module id = 784
// module chunks = 0